module.exports = __webpack_public_path__ + "img/banner_main_m.634f2614.jpg";